import { RouterContext } from "../components/Router";
import { useContext } from "react";
import { RouteComponentProps } from 'react-router';

export default function useRouter<T>() {
	return useContext(RouterContext) as RouteComponentProps<T>;
}
